export const baseURL = "/api/v1";
// export const baseURL = "https://enricher.lotusbetaanalytics.com/api/v1";
// export const baseURL =
//   "https://spectre-e6e5cyaedtc5bwb3.eastus2-01.azurewebsites.net/api/v1";
export const imgURL = baseURL.replace("/api/v1", "");
